<script lang="ts">
  import { onMount } from "svelte";
  import {
    categories,
    products,
    isProductDataLoading,
    fetchProductData,
  } from "../stores/products";
  import { category } from "../stores/filters";
  import Loader from "./Loader.svelte";
  import Product from "./Product.svelte";
  import form, {
    formCount,
    addFormToCart,
    isFormLoading,
  } from "../stores/form";
  import ButtonSpinner from "./ButtonSpinner.svelte";
  import IconButton from "./IconButton.svelte";

  let showSelection = false;

  $: selection = ($products || [])
    .filter((product) => $form[product.id])
    .map((product) => ({
      ...product,
      quantity: $form[product.id],
    }));

  $: filteredProducts = ($products || []).filter(
    (product) => $category === 0 || product.categories.includes($category)
  );

  onMount(async () => {
    await fetchProductData();
  });
</script>

<div class="relative">
  <h2>Tilauslomake</h2>

  <Loader isActive={$isProductDataLoading} />

  <div class="space-y-6">
    <div class="sticky top-0 pt-2 pb-3 bg-white border-b-2">
      <div
        class="flex flex-col gap-2 md:flex-row md:items-center md:justify-between"
      >
        <div>
          <label
            for="order-form-category"
            class="mb-1 flex uppercase font-bold text-gray-400 text-sm"
            >Tuoteryhmä</label
          >
          <select
            name="order-form-category"
            class="px-2 py-2 border-[1px] border-gray-400"
            bind:value={$category}
          >
            <option value={0}>Kaikki</option>
            {#each $categories as category}<option value={category.id}
                >{category.name}</option
              >{#each category.children as child}
                <option value={child.id}>- {child.name}</option>
              {/each}
            {/each}
          </select>
        </div>

        <div class="flex items-center space-x-6">
          {#if $formCount > 0}
            <div>
              <button
                class="flex items-center space-x-1"
                on:click={() => (showSelection = !showSelection)}
              >
                <span
                  >{showSelection ? "Piilota" : "Näytä"} valinta ({$formCount} kpl)</span
                >
                {#if showSelection}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="w-4 h-4"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z"
                      clip-rule="evenodd"
                    />
                  </svg>
                {:else}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="w-4 h-4"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                      clip-rule="evenodd"
                    />
                  </svg>
                {/if}
              </button>
            </div>
          {/if}
          <button
            class="button relative"
            disabled={$formCount === 0 || $isFormLoading}
            on:click={() => addFormToCart()}
          >
            <span>Tilaa valitut</span>

            {#if $isFormLoading}
              <ButtonSpinner />
            {/if}
          </button>
        </div>
      </div>

      {#if showSelection && $formCount > 0}
        <div class="px-6 py-4 bg-gray-100">
          <ul class="md:columns-2 lg:columns-4 mt-0 mb-0 list-none">
            {#each selection as item}
              <li class="ml-0">
                {item.quantity} × <strong>{item.name}</strong>
              </li>
            {/each}
          </ul>
        </div>
      {/if}
    </div>

    {#if filteredProducts.length > 0}
      <div class="space-y-6">
        {#each filteredProducts as product}
          <div
            class="flex flex-col gap-2 md:flex-row md:items-center md:justify-between"
          >
            <Product {product} />

            <div class="flex items-end space-x-4">
              <IconButton
                icon="minus"
                disabled={!$form[product.id]}
                onClick={() => form.decrement(product.id)}
              />
              <div>
                <div class="form-field form-field-number w-20">
                  <label
                    for={`quantity-${product.id}`}
                    class="uppercase font-bold text-gray-400">Kpl</label
                  >
                  <input
                    name={`quantity-${product.id}`}
                    type="number"
                    min="0"
                    step="1"
                    bind:value={$form[product.id]}
                  />
                </div>
              </div>

              <IconButton
                icon="plus"
                onClick={() => form.increment(product.id)}
              />
            </div>
          </div>
          <hr />
        {/each}
      </div>
    {/if}
  </div>
</div>

<style>
  .form-field {
    margin-left: 0;
    margin-bottom: 0;
    line-height: 1;
  }

  .form-field label {
    font-size: 0.75rem;
  }
</style>
